import {locale} from './locale.js';
import Vue from 'vue'
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

const lang = (locale[Vue.$cookies.get('language')] && Vue.$cookies.get('language')) || 'ru-ru';
const text = locale[lang];

export const steps = [
    // {
    //     id : 'calculation_mode',
    //     title: text.stepInfo.calculation_mode.title,
    //     active : true,
    //     description : ''
    // },

    {
        id : 1,
        title: text.stepInfo.heating_appointment.title,
        active : false,
        description : text.stepInfo.heating_appointment.description
    },
    {
        id : 2,
        title: text.stepInfo.insulation_presence.title,
        active : false,
        description : text.stepInfo.insulation_presence.description
    },
    {
        id : 3,
        title: text.stepInfo.heating_square.title,
        active : false,
        description : text.stepInfo.heating_square.description
    },

    {
        id: 'product_list',
        title : text.stepInfo.product_list.title,
        sub_title : text.stepInfo.product_list.sub_title,
        active : false,
        description : text.stepInfo.product_list.description
    }
];

export const criteria = [

    {
        id : 1,
        name : 'heating_appointment',
        inputType : 'radio',
        stepId : 1,
        values : [
            {
                id : 1,
                value : 'open_area',
                text : text.criteriaValues.open_area,
                image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/pavement/open_area.png',
            },
            {
                id : 2,
                value : 'ramps',
                text : text.criteriaValues.ramps,
                image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/pavement/ramps.png',
            },
            {
                id : 3,
                value : 'drive_way',
                text : text.criteriaValues.drive_way,
                image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/pavement/drive_way.png',
            },
            {
                id : 4,
                value : 'stairs',
                text : text.criteriaValues.stairs,
                image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/pavement/stairs.png',
            },
            {
                id : 5,
                value : 'pavement',
                text : text.criteriaValues.pavement,
                image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/pavement/pavement.png',
            },
            {
                id : 6,
                value : 'path',
                text : text.criteriaValues.path,
                image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/pavement/path.png',
            },
        ]

    },

    {
        id : 2,
        name : 'insulation_presence',
        inputType : 'radio',
        stepId : 2,
        values : [
            {
                id : 1,
                value : '0',
                text : text.criteriaValues.no_isulation
            },
            {
                id : 2,
                value : '1',
                text : text.criteriaValues.one_sm_isulation
            },
            {
                id : 3,
                value : '5',
                text : text.criteriaValues.fifth_sm_isulation
            },
        ]
    },
    {
        id : 3,
        name : 'heating_square',
        inputType : 'text',
        required : true,
        unvalid : true,
        stepId : 3,
        placeholder: text.criteriaValues.heating_square_placeholder,
        postfix: 'м<sup>2</sup>',
        title: text.criteriaValues.heating_square,

    },


];